/* eslint-disable react/no-array-index-key */
/* eslint-disable react/function-component-definition */
/* eslint-disable import/no-unresolved */
import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { graphql, useStaticQuery } from 'gatsby'
import Slider from 'react-slick'

// import Image from 'components/elements/Image'
import ParseContent from 'components/shared/ParseContent'
import chevonRightRed from 'img/icons/chevron-right-red.svg'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Plaatjie from '@ubo/plaatjie'

const SlickStyling = createGlobalStyle`
  /* Slider */
  .slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }
  
  .slick-list {
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }

  .slick-list:focus {
    outline: none;
  }

  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }
  
  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  
  .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .slick-track:before,
  .slick-track:after {
    display: table;
    content: '';
  }

  .slick-track:after {
    clear: both;
  }

  .slick-loading .slick-track {
    visibility: hidden;
  }
  
  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
  }

  [dir='rtl'] .slick-slide {
    float: right;
  }

  .slick-slide img {
    display: block;
  }

  .slick-slide.slick-loading img {
    display: none;
  }

  .slick-slide.dragging img {
    pointer-events: none;
  }

  .slick-initialized .slick-slide {
    display: block;
  }

  .slick-loading .slick-slide {
    visibility: hidden;
  }

  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }

  .slick-arrow.slick-hidden {
    display: none;
  }
  
  /* Arrows */
  .slick-prev,
  .slick-next {
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    width: 20px;
    height: 20px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background: transparent;
  }

  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: transparent;
    outline: none;
    background: transparent;
  }

  .slick-prev:hover:before,
  .slick-prev:focus:before,
  .slick-next:hover:before,
  .slick-next:focus:before {
    opacity: 1;
  }

  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: .25;
  }
  
  .slick-prev:before,
  .slick-next:before {
    content: "";
    display: block;
    opacity: .75;
    background-image: url(${chevonRightRed});
    background-repeat: no-repeat;
    background-size: contain;
    width: 12px;
    height: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .slick-prev {
    left: -25px;
    transform: rotate(180deg);
    top: 40px !important;
  }
  
  [dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
  }

  .slick-next {
    right: -25px;
    top: 50px !important;
  }

  [dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
  }
  
  @media (max-width: 767.98px) {
    .slick-prev {
      left: 0;
    }
    
    .slick-next {
      right: 0;
    }
  }
`

const Slide = styled.div`
  outline: none;
`

const Logo = styled.a`
  outline: none;
  width: 100%;
  display: block;
  text-align: center;

  > div {
    margin: 0 auto;
    max-width: 140px;
  }
`

const LogoSlider = ({ title, description, isPartners }) => {
  const { allWpPartner: partners, allWpSamenwerking: cooperation } =
    useStaticQuery(graphql`
      query LogoSliderQuery {
        allWpPartner {
          edges {
            node {
              id
              title
              partner {
                logo {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 140, quality: 100)
                    }
                  }
                }
                link
              }
            }
          }
        }
        allWpSamenwerking {
          edges {
            node {
              id
              title
              recap {
                logo {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 140, quality: 100)
                    }
                  }
                }
                link
                description
              }
            }
          }
        }
      }
    `)

  const items = isPartners ? partners : cooperation

  return (
    <section className="container mb-5">
      <SlickStyling />
      <h2 className="text-center">{title}</h2>
      {description && (
        <div className="row mb-4">
          <div className="col-lg-2" />
          <div className="col-lg-8 text-justify">
            <ParseContent content={description} />
          </div>
        </div>
      )}
      <Slider
        dots={false}
        infinite
        slidesToShow={items.edges.length > 5 ? 5 : items.edges.length}
        slidesToScroll={1}
        autoplay={1}
        autoplaySpeed={3000}
        speed={1000}
        responsive={[
          {
            breakpoint: 996,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
            },
          },
        ]}
      >
        {items.edges.map((item, index) => (
          <Slide key={index}>
            <Logo
              href={`${
                isPartners ? item.node.partner.link : item.node.recap.link
              }`}
              target="_blank"
              rel="noreferrer noopener"
            >
              {isPartners ? (
                <Plaatjie
                  image={item.node.partner.logo}
                  alt={item.node.title}
                />
              ) : (
                <Plaatjie image={item.node.recap.logo} alt={item.node.title} />
              )}
            </Logo>
            {isPartners && item.node.partner.description && (
              <div className="pt-3 font-size-s px-4">
                <ParseContent content={item.node.partner.description} />
              </div>
            )}
            {!isPartners && item.node.recap.description && (
              <div className="pt-3 font-size-s px-4">
                <ParseContent content={item.node.recap.description} />
              </div>
            )}
          </Slide>
        ))}
      </Slider>
    </section>
  )
}

export default LogoSlider
